export default "__VITE_ASSET__CABBujzC__"